import { render, staticRenderFns } from "./FieldType4.vue?vue&type=template&id=a57e4098&scoped=true"
import script from "./FieldType4.vue?vue&type=script&lang=js"
export * from "./FieldType4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57e4098",
  null
  
)

export default component.exports